import React from 'react';
import { observer } from 'mobx-react';
import { PromotionStore } from '@seedlang/stores';
import { isPresent } from '@seedlang/utils';
import { computed } from 'mobx';
import autobind from 'autobind-decorator';
import Grid from 'components/layout/grid';
import ButtonPrimary from 'components/button/button_primary';

@observer
class PromotionCreate extends React.Component {

  @computed get randomSlug() {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';

    for (let i = 0; i < 6; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      result += characters[randomIndex];
    }

    return result;
  }

  @autobind setRandomSlug() {
    if (this.refs.slug.value === '') {
      this.refs.slug.value = this.randomSlug;
    }
  }

  onClick() {
    if (isPresent(this.refs.name.value)) {
      PromotionStore.create(
        {
          data: {
            name: this.refs.name.value,
            slug: this.refs.slug.value,
          },
        },
      );
      this.refs.name.value = '';
      this.refs.slug.value = '';
    }
  }

  render() {
    return (
      <Grid columns={[2,1,1]} gap='sm' style={{marginTop: '10px'}}>
        <input
          placeholder='Add a name'
          ref='name'
          onChange={this.setRandomSlug}
        />
        <input
          placeholder='Add a slug'
          ref='slug'
        />
        <ButtonPrimary onClick={this.onClick.bind(this)}>
          Create
        </ButtonPrimary>
      </Grid>
    );
  }
}

export default PromotionCreate;
